export const RUNS_ENDPOINT = '/api/playbook-runs';
export const AGENT_RUNS_ENDPOINT = '/api/agent-runs';
